import { Button, Callout, InputGroup } from '@blueprintjs/core'
import { lang, utils } from 'enablex/shared'
import _ from 'lodash'
import React, { FC, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import LoadingSection from '~/app/common/LoadingSection'
import { AppState } from '~/app/rootReducer'
import { filterList } from '~/workspace/util'
import cx from 'classnames'
import style from './style.scss'
import DepartmentItem from './Department'

interface Department {
  id: number
  name: string
  email?: string
  status: 'active' | 'suspended'
  workspaceId: string
  createdAt: Date
  updatedAt: Date
}

interface Props {
  departments: Department[]
  loading: boolean
  onDepartmentUpdated: () => void
  openModal: (flag: boolean) => void
  profile?: any
}

const departmentFilterFields = ['name', 'email']

const DepartmentList: FC<Props> = props => {
  const [filter, setFilter] = useState('')
  const [isLaptopScreen, setletIsLaptopScreen] = useState(false)

  // Get current user's role from localStorage
  const currentUserRole = localStorage.getItem('enx/channel-web/user-role')

  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  })

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      })
    }
    window.addEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    setletIsLaptopScreen(windowDimensions.width <= 1344 ? true : false)
  }, [windowDimensions])

  if (!props.departments || props.loading) {
    return <LoadingSection />
  }

  const currentUserEmail = _.get(props.profile, 'email', '').toLowerCase()
  const currentUserisAdminUser = !!_.get(props.profile,'isAdminUser')
  const currentUserisSuperAdmin = !!_.get(props.profile,'isSuperAdmin')
  const currentUserisEnablexAdmin =  !!_.get(props.profile,'isEnablexAdmin')

  // Only show departments for superadmin or manager
  const canManageDepartments = currentUserisSuperAdmin || (currentUserisAdminUser && !currentUserisEnablexAdmin) || (currentUserisAdminUser && currentUserisEnablexAdmin)

  if (!canManageDepartments) {
    return (
      <div style={{ padding: '20px' }}>
        <Callout
          title="Access Denied"
          style={{ textAlign: 'center' }}
        >
          You don't have permission to manage departments.
        </Callout>
      </div>
    )
  }

  const filteredDepartments = filterList(props.departments, departmentFilterFields, filter)

  const branding = utils.getBranding()
  const brandName = branding?.pageTitle || 'EnableX Dialogs'

  return (
    <div className={cx(style.containerLeft, { [style.show]: !isLaptopScreen })}>
      <div className={cx({ [style.forLaptop]: !isLaptopScreen })}>
        <div className={style.filterWrapper}>
          <div className={style.filterTitleContainer}>
            <div className={style.filterTitle}>Departments</div>
            <InputGroup
              id="input-filter"
              placeholder="Filter departments..."
              value={filter}
              onChange={e => setFilter(e.target.value.toLowerCase())}
              autoComplete="off"
              type="search"
              className={style.searchUsersFilter}
            />
          </div>
          <Button
            id="btn-create-department"
            text="Add Department"
            icon="add"
            onClick={() => props.openModal(true)}
            className={style.createNewUserBtn}
          />
        </div>

        <div className={style.container}>
          <div className={style.heroSectionText}>
            View and manage departments for your workspace.
          </div>

          {!props.departments.length && (
            <Callout
              className={style.filterCallout}
              title="No departments yet"
              style={{ textAlign: 'center' }}
            >
              Create your first department to get started.
            </Callout>
          )}

          {props.departments.length > 0 && (
            <div className={style.departmentsGridContainer}>
              {filteredDepartments.map(department => (
                <DepartmentItem
                  key={department.id}
                  department={department}
                  currentUserEmail={currentUserEmail}
                  currentUserisAdminUser={currentUserisAdminUser}
                  currentUserisSuperAdmin={currentUserisSuperAdmin}
                  currentUserisEnablexAdmin={currentUserisEnablexAdmin}
                  onDepartmentUpdated={props.onDepartmentUpdated}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {!isLaptopScreen && (
        <div
          style={{
            width: '25%',
            background: '#fff',
            height: 'fit-content',
            borderRadius: '10px',
            padding: '10px 1.5rem 1.5rem 1.5rem'
          }}
        >
          <h3>Get started with {brandName}</h3>
          <div>
            <video
              src={'https://portal.enablex.io/dialogs/EnableX_Engage_bot.mp4'}
              poster={'admin/video/video_poster.jpg'}
              preload="auto"
              style={{ width: '100%' }}
              controls
            />
          </div>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  profile: state.user.profile
})

const connector = connect(mapStateToProps, {})

export default connector(DepartmentList)
